import userTeamService from '../services/userTeamService';

/** The portal a user (or viewed-as role) works from: where their tasks and pending file notes live. */
export function resolveHomePortalTab(userEmail, viewAsRole) {
  if (viewAsRole === 'paraplanner') return 'paraplannerPortal';
  if (viewAsRole) return 'advisoryPortal';
  const role = userEmail ? userTeamService.getUserRole(userEmail) : null;
  return role === 'paraplanner' ? 'paraplannerPortal' : 'advisoryPortal';
}
